const data = {
  data: {
    Respuesta: [],
    // Respuestas: [{ Respuesta: '', blnError: false, codError: null, msgError: null }],
    blnError: false,
    codError: null,
    msgError: null
  }
}
  
export default data
